/* eslint-disable import/no-unused-modules */

import { BaseVariant, FeatureFlag, useBaseFlag } from '../index'

export function useMgtmFlag(): BaseVariant {
  return useBaseFlag(FeatureFlag.mgtm)
}

export { BaseVariant as MgtmVariant }
